export const PERMISSION_RESOURCE_CODES = {
  permission: 'permission',
  taskApplicationAdministrator: 'task_application_administrator',
} as const;

export const PERMISSION_ACTION_CODES = {
  permission: {},
  taskApplicationAdministrator: {},
};
